import React, { useState } from 'react';
import { Circle, Wrapper } from './Toggler.styles';
import { TogglerKeys } from '../../hooks/useReport';

interface TogglerProps<T extends TogglerKeys> {
  name: T;
  handleToggleState: (name: T) => void;
}

const Toggler = <T extends TogglerKeys>({ name, handleToggleState }: TogglerProps<T>) => {
  const [isActive, setIsActive] = useState(false);
  const handleToggle = () => {
    setIsActive(state => !state);
    handleToggleState(name);
  };
  return (
    <Wrapper onClick={handleToggle} active={isActive}>
      <Circle active={isActive} />
    </Wrapper>
  );
};

export default Toggler;
